import React from 'react';
import styled from 'styled-components';
import {APP_VERSION} from 'version';

const ImprintScreen = () => (
  <Container>
    <h1>Impressum</h1>
    <p>
      Diese Applikation wurde von Europify im Rahmen des Projektes &quot;Demokratie lernen -
      Zusammenleben gestalten&quot; entwickelt und vom Bundesministerium für Frauen, Wissenschaft
      und Forschung finanziert.
    </p>
    <p>
      Europify ist ein unabhängiges Institut mit Schwerpunkt Europäische Bildung und Integration.
      Das Institut bemüht sich vor allem um die Hebung der europäischen Kompetenz im gesamten
      Bildungsbereich sowie um die Vertiefung der europäischen Integration auf allen Ebenen der
      Gesellschaft.
    </p>
    <p>
      Demokratiebildung, Grundwertevermittlung und Empowerment zur aktiven Beteiligung an
      gesellschaftlichen Prozessen schon von klein auf ist uns ein Anliegen.
    </p>
    <p>
      Europify ist federführend in innovativen Projekten europaweit tätig und ist für interessante
      Kooperationen immer offen.
    </p>

    <h2>Projektdurchführung</h2>
    <p>
      <b>Europify - Unabhängiges Institut für europäische Bildung &amp; Integration</b>
    </p>
    <p>
      Obmann: Dr. Bernhard Köhle
      <br />
      Vereinssitz: Laudongasse 44/1/9, 1080 Wien, Österreich / EU
      <br />
      ZVR: 1710705048
    </p>
    <p>
      Web: https://europify.at
      <br />
      E-Mail: office@europify.at
      <br />
      Telefon: +43 650 6667282
    </p>
    <LogoEuropify />

    <h2>Technische Beratung und Umsetzung</h2>
    <p>
      <b>DI Stefan Hynst - Software & Multimedia Development</b>
    </p>
    <p>
      Firmensitz: Turmburggasse 16/9, 1060 Wien, Österreich / EU
      <br />
      UID-Nr: ATU66737588
    </p>
    <p>
      Web: https://hynst.at
      <br />
      E-Mail: info@hynst.at
      <br />
      Telefon: +43 699 11749340
    </p>
    <LogoSH />

    <h2>Quellen</h2>
    <p>Eurostat, Unterlagen der Europäischen Union, WKO, Bilder - Unsplash</p>

    <h2>Version</h2>
    <code>{APP_VERSION}</code>
  </Container>
);
export default ImprintScreen;

const Container = styled.div`
  padding: 100px;

  @media screen and (max-height: 1200px) {
    font-size: 14px;
    padding: 2em;
    overflow-y: scroll;
  }

  & h1 {
    line-height: 1em;
    margin-top: 0;
  }

  & h2 {
    line-height: 1em;
    margin-top: 1.5em;
  }
`;

const Logo = styled.div`
  background-size: contain;
  background-repeat: no-repeat;
  display: none;

  --logo-scale: 1;

  @media screen and (min-height: 900px) {
    display: block;
  }
  @media screen and (min-height: 970px) {
    --logo-scale: 2;
  }
`;

const LogoEuropify = styled(Logo)`
  height: calc(0.5 * var(--logo-scale) * var(--logo-bar-height));
  aspect-ratio: 2.5274;
  background-image: url('logoEuropify.svg');
`;

const LogoSH = styled(Logo)`
  height: calc(0.333 * var(--logo-scale) * var(--logo-bar-height));
  aspect-ratio: 5.9884;
  background-image: url('logoSH.svg');
`;
